import { render, staticRenderFns } from "./CaseDetailV2.vue?vue&type=template&id=414cdd5d&scoped=true"
import script from "./CaseDetailV2.vue?vue&type=script&lang=js"
export * from "./CaseDetailV2.vue?vue&type=script&lang=js"
import style0 from "./CaseDetailV2.vue?vue&type=style&index=0&id=414cdd5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414cdd5d",
  null
  
)

export default component.exports